import styled from 'styled-components'
import tw from 'twin.macro'


export const HeroImage = styled.div`
  background-color: rgb(37, 51, 213);
  ${tw`flex justify-center`}
`